import intl from 'react-intl-universal';

import { Checkbox, FormControlLabel, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

import { useMaterialUIController } from 'context';

import localData from 'utils/localData';
import { USER_DATA } from 'shared/constants/users';

const propTypes = {
  tagList: PropTypes.array.isRequired,
  selectedTagIds: PropTypes.array.isRequired,
  setSelectedTagIds: PropTypes.func.isRequired,
  openCheckboxForm: PropTypes.bool.isRequired,
  setOpenCheckboxForm: PropTypes.func.isRequired,
};

const DashboardNewTagCheckboxForm = ({
  tagList,
  selectedTagIds,
  setSelectedTagIds,
  openCheckboxForm,
  setOpenCheckboxForm,
}) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const handleBoxClick = (event) => {
    const index = event.target.id;
    const checked = selectedTagIds.includes(tagList[index].id);
    const updatedSelectedTagIds = checked
      ? selectedTagIds.filter((id) => id !== tagList[index].id)
      : [...selectedTagIds, tagList[index].id];
    setSelectedTagIds(updatedSelectedTagIds);
  };

  const renderTags = () => {
    if (tagList) {
      return (
        <Box sx={{ width: '100%' }}>
          <Grid container spacing={2}>
            {tagList.map((tag, index) => {
              const language = localData.get(USER_DATA.PREFFERED_LANGUAGE);
              const labelText =
                tag.displayName[language] ||
                tag.displayName['en-US'] ||
                Object.values(tag.displayName)[0];
              return (
                <Grid size={12} key={index}>
                  <Box
                    sx={{
                      width: '100%',
                    }}>
                    <FormControlLabel
                      style={{
                        color: darkMode ? 'white' : 'black',
                        width: '100%',
                        margin: 0,
                      }}
                      control={
                        <Checkbox
                          sx={{
                            color: '##66ccff', // Unchecked border and icon color
                            '&.Mui-checked': {
                              color: '#1976d2', // Checked color
                            },
                            '& .MuiSvgIcon-root': {
                              border: '2px solid #66ccff', // Custom border for the box
                              borderRadius: '4px', // Optional: rounded corners
                            },
                          }}
                          checked={selectedTagIds.includes(tag.id)}
                          onChange={handleBoxClick}
                          name={labelText}
                          id={index.toString()}
                        />
                      }
                      label={labelText}
                    />
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      );
    }
  };

  return (
    <Card
      data-testid="new-issue-tags-modal-contents"
      sx={{
        width: 900,
        maxHeight: 1200,
        overflow: 'auto',
      }}>
      <MDBox py={3} px={3} mt={3} mx={3}>
        {renderTags()}
        <Grid container alignItems="flex-end">
          <Grid size={12}>
            <Box
              display="flex"
              justifyContent="center"
              sx={{ marginTop: '20px' }}>
              <MDButton
                color="info"
                style={{
                  color: 'white',
                  width: '10%',
                }}
                onClick={() => setOpenCheckboxForm(!openCheckboxForm)}>
                {intl.get('new_modal_tag_confirm')}
              </MDButton>
            </Box>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
};

DashboardNewTagCheckboxForm.propTypes = propTypes;

export default DashboardNewTagCheckboxForm;
